import { ActionBarContainer, Button, Dropdown, TActionBar, Typography } from "@cakemail-org/ui-components-v2"
import { Stack } from "@mui/material"
import { useMemo } from "react"
import { useTranslation } from "react-i18next"
import { TContactActionBar } from "./types"

export function ContactActionBar({
    selectedContacts,
    contacts,
    selectAllPages,
    handlePageSelection,
    handleToggleInterestManager,
    handleUnsubscribeContacts,
    handleSuppressContacts,
    handleDeleteContacts,
    handleCloseActionRow
}: TContactActionBar) {
    const { t } = useTranslation()

    const actionRowBars: TActionBar[] = useMemo(() => [
        {
            className: "contactsActionsRow",
            content: <Stack direction="row" gap={8} alignItems="center">
                <Stack direction="row" gap={4} alignItems="center">
                    <Typography variant="body1L" className="semiBold uppercase">{t("contacts-selections-count", { count: selectedContacts?.length })}</Typography>
                    <Button
                        onClick={handlePageSelection}
                        variant="outlined"
                        size="medium"
                        color="body1"
                    >
                        {t(selectedContacts?.length !== contacts?.data?.length ? "general-select-page" : selectAllPages ? "general-select-page" : "general-select-all-pages")}
                    </Button>
                </Stack>
                <Stack direction="row" gap={4} alignItems="center">
                    <Dropdown
                        menuPlacement="top"
                        defaultValue={""}
                        options={[
                            { text: t("general-add-remove-interests"), isAction: true, value: "interests", onClick: handleToggleInterestManager },
                            { text: t("general-add-remove-tags"), isAction: true, value: "tags", onClick: handleUnsubscribeContacts },
                            ...(!selectAllPages ? [
                                { text: t("general-unsubscribe_one"), isAction: true, value: "unsubscribe", onClick: handleUnsubscribeContacts },
                                { text: t("general-add-to-suppression-list"), isAction: true, value: "suppress", onClick: handleSuppressContacts },
                                { text: t("general-delete"), isAction: true, value: "delete", onClick: handleDeleteContacts }
                            ] : [])
                        ]}
                        placeholder={t("general-action_other")}
                    />
                    <Button
                        variant="contained"
                        size="medium"
                        color="secondary"
                        onClick={handleCloseActionRow} iconOnly>
                        {t("general-close")}
                    </Button>
                </Stack>
            </Stack>
        }
    ], [selectedContacts, contacts?.data, selectAllPages])

    return <ActionBarContainer
        position="bottom"
        open={true}
        className="contactsAction"
        bars={actionRowBars}
    />
}